import { ERROR_PAGE, PAGE_NOT_FOUND_URL } from "./uri";

export type HistoryLike = {
    push: (path: string) => void;
    replace: (path: string) => void;
};

/** Opt a request into interceptor-driven 404/error-page navigation. */
export const REDIRECT_ON_FAILURE = { redirectOnFailure: true as const };

export const getRequestStatus = (error: any): number | undefined =>
    error?.status ?? error?.response?.status;

export const redirectOnRequestFailure = (history: HistoryLike, error: any) => {
    if (getRequestStatus(error) === 404) {
        history.replace(PAGE_NOT_FOUND_URL);
        return;
    }
    history.push(ERROR_PAGE);
};
